import styled from 'styled-components';
export const ActionsLine = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
